import { hex as b16, base64 as b64, bech32m as b32m } from '@scure/base';
/**
 * Interface for encoding two and from base16 / hex.
 */
export var base16;
(function (base16) {
    /**
     * Encodes the given bytes as a hex string.
     */
    function encode(data) {
        return b16.encode(data);
    }
    base16.encode = encode;
    /**
     * Decodes the given hex string to bytes.
     */
    function decode(str) {
        return b16.decode(str);
    }
    base16.decode = decode;
})(base16 || (base16 = {}));
/**
 * Interface for encoding two and from base64.
 */
export var base64;
(function (base64) {
    /**
     * Encodes the given bytes as a base64 string.
     */
    function encode(data) {
        return b64.encode(data);
    }
    base64.encode = encode;
    /**
     * Decodes the given base64 string to bytes.
     */
    function decode(str) {
        return b64.decode(str);
    }
    base64.decode = decode;
})(base64 || (base64 = {}));
/**
 * Interface for encoding two and from bech32m.
 */
export var bech32m;
(function (bech32m) {
    /**
     * Encodes the given bytes as a bech32 string with the specified prefix.
     */
    function encode(data, prefix = '') {
        const words = b32m.toWords(data);
        return b32m.encode(prefix, words, 192);
    }
    bech32m.encode = encode;
    /**
     * Decodes the given bech32 string to bytes, ensuring a matching prefix.
     */
    function decode(str, prefix = '') {
        const result = b32m.decode(str, 192);
        if (result.prefix === prefix) {
            return b32m.fromWords(result.words);
        }
        else {
            throw Error(`invalid prefix: ${prefix}`);
        }
    }
    bech32m.decode = decode;
})(bech32m || (bech32m = {}));
